export default function (){
    return {
        openLiveChat: function ({ sessionStarted = false } = {}) {
           if(sessionStarted){
                window.chaport.q('open');
            }else{
                window.open('https://app.chaport.com/widget/show.html?appid=632a193f5b2caaff77924cb4', '_blank');              
            }

        }
    }
}